import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SleddingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sledding"}/>
}
